import { atom } from 'jotai';

/**
 * Open state of the F4 ecom modal (the legacy `Variants` dialog). Lives in an
 * atom so sections other than the purchase row — e.g. the F5 meta row's
 * swatches/chips — can open the purchase path.
 */
export const purchaseModalOpenAtom = atom(false);
